import { computed } from 'mobx'
import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import type { ITableModelDefault } from 'shared/ui/TableNew'
import type { MessagingAnalyticsKeys } from 'entities/Analytics/api/types'
import type { AnalyticsComparisonEntity } from 'pages/analytics/ui'

export interface IMessagesComparisonData extends ITableModelDefault {
  id: string | number
  name: string
  metrics: Record<MessagingAnalyticsKeys, number>
  breakdownEntity?: AnalyticsComparisonEntity
}

export class RowMessagesComparison extends RowBase<IMessagesComparisonData> {
  constructor(data: IMessagesComparisonData) {
    super(data)

    makeObservableRowBase(this, {
      fields: computed,
    })
  }

  get fields() {
    return {
      name: this.origin.name,
      total_inbound: this.origin.metrics.total_inbound,
      total_outbound: this.origin.metrics.total_outbound,
      delivered: this.origin.metrics.delivered,
      undelivered: this.origin.metrics.undelivered,
      carrier_violations: this.origin.metrics.carrier_violations,
      optouts: this.origin.metrics.optouts,
      total_rvm: this.origin.metrics.total_rvm,
      delivered_rvm: this.origin.metrics.delivered_rvm,
      undelivered_rvm: this.origin.metrics.undelivered_rvm,
      breakdownEntity: this.origin.breakdownEntity,
    }
  }
}
